import { render, staticRenderFns } from "./repeater-drop-zone.vue?vue&type=template&id=63e4364a&scoped=true&"
import script from "./repeater-drop-zone.vue?vue&type=script&lang=js&"
export * from "./repeater-drop-zone.vue?vue&type=script&lang=js&"
import style0 from "./repeater-drop-zone.vue?vue&type=style&index=0&id=63e4364a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e4364a",
  null
  
)

export default component.exports